
module.exports = {
	LOCALES: require('./locale'),
	OPTIONS: require('./options'),
	POSTAL: require('./postal'),
	CATEGORY: require('./104Categories'),
	... require('./message'),
	// MESSAGE: require('./message').MESSAGE,
	// ERROR: require('./message').ERROR,
	... require('./menu'),
	// MENU: require('./menu').MENU,
	// MENU_DEV: require('./menu').MENU_DEV,
	MENU_PORTAL: require('./menu-portal').MENU,
	UPLOAD: require('./upload'),
	MAIL_TEMPLATE: require('./mailTemplate'),
	SYS_VERSION: require('./sysVersion'),
	AUTH_EXCLUDE: require('./authExclude'),
	AUTH_ZZC: require('./authZZC'),
};
